<script>
  import { createEventDispatcher } from 'svelte';
  import { Checkbox, Modal } from 'carbon-components-svelte';

  const dispatch = createEventDispatcher();

  export let open = false,
    disabled = false;

  let understand = false;

  function stopPropagation(event) {
    event.stopPropagation();
  }

  function onCheck({ detail: checked }) {
    understand = checked;
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  bind:open
  size="sm"
  modalHeading="Reload inventory"
  primaryButtonText="Reload"
  secondaryButtonText="Cancel"
  shouldSubmitOnEnter={false}
  primaryButtonDisabled={disabled || !understand}
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit
>
  <p>
    Are you sure you want to reload inventory? You should <em>only</em> reload if a newly created data feed (under AWS Raw Feeds) does not appear
    in the data feed list.
  </p>
  <br />
  <p>
    <strong>Important!</strong> Reloading inventory takes a few minutes. If you recently triggered one, wait for some time before triggering
    a new one.
  </p>
  <div class="understand">
    <Checkbox labelText="I understand and I want to proceed" checked={understand} on:click={stopPropagation} on:check={onCheck} />
  </div>
</Modal>

<style>
  .understand {
    margin-top: 2rem;
  }
</style>
